// @ts-strict-ignore
export const CURRENCY_SIMBOL = '£'

export const isEmpty = (value: any) => value === null || value === '' || value === undefined

export const FormatCurrency = (_value: any, _currency = 'GBP', _currencyTag = CURRENCY_SIMBOL) => {
  if (isEmpty(_value)) return ''
  let value = 0
  if (isNaN(_value)) {
    value = _value
      .toString()
      .replace(_currencyTag, '')
      .replaceAll(',', '')
      .replace(/\D/, '')
      .substring(0, 8)
  } else {
    value = _value
  }
  return new Intl.NumberFormat({ style: 'currency', currency: _currency }).format(value)
}

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const getFormattedDate = (value: any) =>
  new Date(new Date().setMonth(new Date().getMonth() + value))
